import { ReduceStore } from "flux/utils";
import { Record, Map } from "immutable";
import AppDispatcher from "../AppDispatcher";
import Constants from "../Constants";

class Membership extends Record({
  id: null,
  userId: null,
  organizationId: null,
  role: null,
  tableauUser: null,
  eulaAcceptance: null,
}) {}

function loadMemberships(state, userId, memberships) {
  const newValues = new Map(
    memberships.map((membership) => [
      membership.id,
      new Membership({
        id: membership.id,
        userId,
        organizationId: membership.organization.id,
        role: membership.role.id,
        tableauUser: membership.detail.tableau_user,
        eulaAcceptance: membership.eula_acceptance,
      }),
    ])
  );
  return state.merge(newValues);
}

function setMembership(state, newMembership) {
  return state.set(
    newMembership.id,
    new Membership({
      id: newMembership.id,
      userId: newMembership.user.id,
      organizationId: newMembership.organization.id,
      role: newMembership.role.id,
      tableauUser: newMembership.detail.tableau_user,
      eulaAcceptance: newMembership.eula_acceptance,
    })
  );
}

class MembershipStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.USER_DATA_LOADED:
        return loadMemberships(
          state,
          action.userId,
          action.payload.memberships
        );
      case Constants.Admin.MEMBERSHIP_CREATED:
        return setMembership(state, action.membership);
      case Constants.Admin.CURRENT_USER_LOADED:
        return loadMemberships(state, action.user.id, action.user.memberships);
      default:
        return state;
      // do nothing
    }
  }

  getMembershipsByUser(userId) {
    return this.getState()
      .filter((m) => m.userId === userId)
      .toList();
  }

  getMembership(userId, organizationId) {
    return this.getState().find(
      (m) => m.userId === userId && m.organizationId === organizationId
    );
  }

  get(id, defaultValue = null) {
    return this.getState().get(id, defaultValue);
  }
}

const instance = new MembershipStore(AppDispatcher);
export default instance;
